export function isDateToday(dateToCheck: Date): boolean {
    const today = new Date();
    return (
        dateToCheck.getDate() === today.getDate() &&
        dateToCheck.getMonth() === today.getMonth() &&
        dateToCheck.getFullYear() === today.getFullYear()
    );
}

